export const recentSearches = ["58 Via Plauto, Prati"];
